// extracted by mini-css-extract-plugin
export default {"header":"RJ","discountBanner":"SJ","logo":"TJ","maincontainer":"UJ","videocontainer":"VJ","videowelcome":"WJ","videowrapper":"XJ","videosale":"YJ","loadingcontainer":"ZJ","footer":"aK","footerbutton":"bK","video":"cK","logoname":"eK"};
    if(module.hot) {
      // 1737143662228
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  